import { DialogContent, DialogContentProps } from '@material-ui/core';
import React from 'react';

export type ModalWindowContentProps = DialogContentProps & {

}

export function ModalWindowContent ({ dividers, ...props }: ModalWindowContentProps) {
    return <DialogContent {...props} dividers={dividers !== false} />
}